// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Checkbox--2y_ve{width:16px;height:16px;min-width:16px;min-height:16px;border:1px solid #b2c4d7;display:flex;align-items:center;justify-content:center;border-radius:3px;cursor:pointer}.Checkbox--2y_ve.Active--2_UkS{background-color:#5276f7;border-color:#5276f7}.ChkbxLabel--WKD8o{margin-left:8px}.Disabled--2XWtB{opacity:.6;cursor:auto}", ""]);
// Exports
exports.locals = {
	"Checkbox": "Checkbox--2y_ve",
	"Active": "Active--2_UkS",
	"ChkbxLabel": "ChkbxLabel--WKD8o",
	"Disabled": "Disabled--2XWtB"
};
module.exports = exports;
